/**
 * Registers the service worker (public/sw.js) for the installable, offline-capable app.
 *
 * Only in production builds, so `npm run dev` and its hot reload are never served from a cache. Automated browsers
 * (navigator.webdriver, e.g. the Playwright suite) are skipped too, so tests always talk to the live server. Either
 * can be overridden for testing the worker itself: localStorage.setItem('assetos_sw', '1').
 */
export function swEnabled() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return false;
  let flag = null;
  try {
    flag = localStorage.getItem('assetos_sw');
  } catch {
    flag = null;
  }
  if (flag === '0') return false;
  if (flag === '1') return true;
  return Boolean(import.meta.env.PROD) && !navigator.webdriver;
}

export function registerServiceWorker() {
  if (!swEnabled()) return;
  const version = import.meta.env.VITE_BUILD_ID || 'dev';
  const register = () => navigator.serviceWorker.register(`/sw.js?v=${encodeURIComponent(version)}`, { scope: '/' }).catch(() => {});
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}

/** Sign-out on a shared device: the worker forgets every cached API response. */
export function clearApiCache() {
  try {
    navigator.serviceWorker?.controller?.postMessage({ type: 'clear-api-cache' });
  } catch {
    /* no worker */
  }
}
